//
import service from '../../utils/server'
export const getPersonInfo = data => {
    return service({
        url: '/fmUser/login',
        method: 'post',
        data
    })
};

export const fmUserChangeUserPwd = data => {
  return service({
    url: '/fmUser/editPwd',
    method: 'post',
    data
  })
};

// export const fmRoleUserData = data => {
//     return service({
//         url: '/fmRole/getRoleInfoByName',
//         method: 'post',
//         data
//     })
// };

export const fmRoleUserAddData = data => {
    return service({
        url: '/fmRole/addRole',
        method: 'post',
        data
    })
};

export const fmRoleUpdateData = data => {
    return service({
        url: '/fmRole/updateRole',
        method: 'post',
        data
    })
};

export const fmUserQueryList = data => {
    return service({
        url: '/fmUser/getUsersByNoOrName',
        method: 'post',
        data
    })
};

export const fmUserLogin = data => {
    return service({
        url: '/fmUser/login',
        method: 'post',
        data
    })
};
export const fmUserLoginOut = data =>{
  return service({
    url: '/fmUser/out',
    method: 'post',
    data
  })
}
export const queryPowerByMenuId = data => {
  return service({
    url: '/fmPageOp/queryPowerByMenuId',
    method: 'post',
    data
  })
};

//自动登录
export const loginInfo = data => {
  return service({
    url: '/login/info',
    method: 'post',
    data
  })
};

/**
 * 查询用户可操作品牌柜台对应得角色列表
 */
export const getCounterBrandRoleList = data => {
  return service({
    url: '/fm/fmUser/getCounterBrandRoleList',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/view/api/ajax.js